<template>
  <div class="game-cards">
    <WCasinoCardSkeleton v-for="i in 12" :key="i" class="card" />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="css" scoped>
.game-cards {
  position: relative;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  gap: var(--spacing-200) var(--spacing-125);
}

.card {
  min-width: 0;
}
</style>
